module.exports = __webpack_public_path__ + "static/media/map6.31dd00ae.gif";